module.exports = __webpack_public_path__ + "static/media/hippo.5f4aad2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animalImage/img/hippo.svg
// module id = 136
// module chunks = 0